module.exports = __webpack_public_path__ + "assets/img/template_img.a8e8f26a.svg";